import Feedback from 'modules/Feedback/Feedback';

export const App = () => {
  return (
    <>
      <Feedback />
    </>
  );
};
